// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BuildSidebar.css */

.build-sidebar {
  position: fixed;
  top: 6em;
  right: 0;
  width: 50%;
  height: calc(
    100% - 8em
  ); /* Adjust height to account for the fixed top position */
  background-color: #fff;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
  overflow-y: auto;
  color: #000;
  font-family: "Fivo Sans Regular", sans-serif;
}
.export-excel-button {
  padding: 0.5em 1em;
  font-family: "Fivo Sans Regular", sans-serif;
  font-size: 1em;
  background-color: #b51f25;
  color: #fff;
  border: 2px solid #b51f25;
  border-radius: 0.25em;
  cursor: pointer;
  margin-bottom: 1em;
}
.export-excel-button:hover {
  background-color: #9e1c20;
}
.sidebar-actions {
  display: flex;
  justify-content: space-between;
  padding: 0 1em;
}
.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-family: "Fivo Sans Medium", sans-serif;
}

.sidebar-card-title {
  font-size: 1em;
  margin: 10px 0;
  text-transform: capitalize;
}

.close-sidebar-button {
  color: #f0f0f0;
  font-size: 0.85em;
}

.edit-build-button {
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  top: 0.625em;
  left: 0.625em;
  background-color: #009a00;
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 0.5em;
  font-family: "Fivo Sans Medium", sans-serif;
}

.edit-build-button:hover {
  background-color: #008000;
}

.accordion-item {
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 10px;
  overflow: hidden;
}

.accordion-header {
  background-color: #f2f2f2;
  padding: 10px;
  cursor: pointer;
  font-family: "Fivo Sans Medium", sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.accordion-body {
  padding: 10px;
  background-color: #fff;
}

.accordion-body.show {
  display: block;
}

.table-wrapper {
  overflow-x: auto;
}

.sidebar-table {
  min-width: 600px;
  border-collapse: collapse;
  margin-top: 20px;
  width: 100%;
}

.sidebar-table th,
.sidebar-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.sidebar-table th {
  background-color: #f2f2f2;
  text-align: left;
  font-size: 0.8em;
  text-transform: capitalize;
}

.sidebar-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.sidebar-table td {
  font-size: 0.7em;
}

.sidebar-table-image {
  max-width: 100px;
  height: auto;
}

.back-button {
  display: inline-block;
  margin-bottom: 10px;
  padding: 8px 12px;
  background-color: #009a00;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-family: "Fivo Sans Medium", sans-serif;
}

.back-button:hover {
  background-color: #008000;
}

.icon {
  font-size: 1em;
  margin-right: 10px;
  margin-right: 10px;
}

.rotate-icon {
  transform: rotate(180deg);
}

.add-button {
  display: inline-block;
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #009a00;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 0.8em;
}

.add-button:hover {
  background-color: #008000;
}
`, "",{"version":3,"sources":["webpack://./src/components/YourCreations/BuildSidebar.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,UAAU;EACV;;GAEC,EAAE,wDAAwD;EAC3D,sBAAsB;EACtB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,2CAA2C;EAC3C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* BuildSidebar.css */\n\n.build-sidebar {\n  position: fixed;\n  top: 6em;\n  right: 0;\n  width: 50%;\n  height: calc(\n    100% - 8em\n  ); /* Adjust height to account for the fixed top position */\n  background-color: #fff;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  overflow-y: auto;\n  color: #000;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n}\n.export-excel-button {\n  padding: 0.5em 1em;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  font-size: 1em;\n  background-color: #b51f25;\n  color: #fff;\n  border: 2px solid #b51f25;\n  border-radius: 0.25em;\n  cursor: pointer;\n  margin-bottom: 1em;\n}\n.export-excel-button:hover {\n  background-color: #9e1c20;\n}\n.sidebar-actions {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 1em;\n}\n.sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n}\n\n.sidebar-card-title {\n  font-size: 1em;\n  margin: 10px 0;\n  text-transform: capitalize;\n}\n\n.close-sidebar-button {\n  color: #f0f0f0;\n  font-size: 0.85em;\n}\n\n.edit-build-button {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  position: absolute;\n  top: 0.625em;\n  left: 0.625em;\n  background-color: #009a00;\n  border: none;\n  color: white;\n  cursor: pointer;\n  border-radius: 0.5em;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n}\n\n.edit-build-button:hover {\n  background-color: #008000;\n}\n\n.accordion-item {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n\n.accordion-header {\n  background-color: #f2f2f2;\n  padding: 10px;\n  cursor: pointer;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.accordion-body {\n  padding: 10px;\n  background-color: #fff;\n}\n\n.accordion-body.show {\n  display: block;\n}\n\n.table-wrapper {\n  overflow-x: auto;\n}\n\n.sidebar-table {\n  min-width: 600px;\n  border-collapse: collapse;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.sidebar-table th,\n.sidebar-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n}\n\n.sidebar-table th {\n  background-color: #f2f2f2;\n  text-align: left;\n  font-size: 0.8em;\n  text-transform: capitalize;\n}\n\n.sidebar-table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.sidebar-table td {\n  font-size: 0.7em;\n}\n\n.sidebar-table-image {\n  max-width: 100px;\n  height: auto;\n}\n\n.back-button {\n  display: inline-block;\n  margin-bottom: 10px;\n  padding: 8px 12px;\n  background-color: #009a00;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n}\n\n.back-button:hover {\n  background-color: #008000;\n}\n\n.icon {\n  font-size: 1em;\n  margin-right: 10px;\n  margin-right: 10px;\n}\n\n.rotate-icon {\n  transform: rotate(180deg);\n}\n\n.add-button {\n  display: inline-block;\n  margin-top: 10px;\n  padding: 8px 12px;\n  background-color: #009a00;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 0.8em;\n}\n\n.add-button:hover {\n  background-color: #008000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
